import LoginForm from '@components/membership/forms/LoginForm';
import AuthenticationStore from '@components/membership/stores/AuthenticationStore';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import Login from '../common/Login';
import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export interface LoginDialogProps {
    authenticationStore: AuthenticationStore,
}

const LoginDialog: FC<LoginDialogProps> = observer(({ authenticationStore }) => {
    const { isLoginDrawerOpen, setIsLoginDrawerOpen } = authenticationStore;

    const handleClose = () => {
        setIsLoginDrawerOpen(false);
    };

    return (
        <Dialog
            onClose={handleClose}
            open={isLoginDrawerOpen}
            maxWidth={"xs"}
            sx={{
                "& .MuiDialog-paper": {
                    width: "100%",
                }
            }}>
            <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                sx={{
                    position: "absolute",
                    top: 4,
                    right: 8
                }}
            >
                <CloseIcon />
            </IconButton>

            <Box p={6}>
                <Login authenticationStore={authenticationStore} />
            </Box>

        </Dialog>
    );
});

export default LoginDialog;